import { ApiResult, request, safeRequest } from '@synergy/api';
import { noop } from '@synergy/utils';

import { Account } from '../models/account';

export class AccountApi {
    constructor(protected baseUrl: string) {}

    public updateAccountLastChecked(): Promise<ApiResult<void>> {
        return safeRequest(
            () => request.patch(`${this.baseUrl}/update-account-last-checked`, { lastCheckedDate: new Date() }),
            noop
        );
    }

    public changeAccount(accountId: number): Promise<ApiResult<Account>> {
        return safeRequest(
            () => request.post(`${this.baseUrl}/change-account/${accountId}`),
            response => response.data
        );
    }
}
